import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const SingleBlog = () => {
  const { id } = useParams(); // Get the blog ID from the URL parameters
  const [blog, setBlog] = useState(null); // State to store the blog data
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [error, setError] = useState(null); // State to manage error messages

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        if (!id) {
          throw new Error("No ID provided in URL.");
        }
        console.log("Fetching Blog with ID:", id); // Debugging log
        const response = await axios.get(
          `http://localhost:9000/api/blogs/${id}`
        );
        console.log("Fetched blog data:", response.data); // Debugging log
        setBlog(response.data); // Set the blog data
      } catch (err) {
        console.error("Error fetching blog:", err);
        setError("Blog not found or there was an error fetching the data.");
      } finally {
        setLoading(false); // Update loading state
      }
    };

    fetchBlog(); // Call the fetch function when the component mounts
  }, [id]); // Re-run the effect if the ID changes

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-10 text-center">
        <h1 className="text-3xl font-bold mb-4">Loading...</h1>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-10 text-center">
        <h1 className="text-3xl font-bold mb-4">{error}</h1>
        <p>The blog you're looking for does not exist.</p>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="container mx-auto px-4 py-10 text-center">
        <h1 className="text-3xl font-bold mb-4">No Blog Found</h1>
        <p>The blog you're looking for does not exist or has been removed.</p>
      </div>
    );
  }

  return (
    <div className="">
      
      <div className="container mx-auto mt-10">
        {/* Meta Section */}
        {blog.title && (
          <div className=" text-left">
            <h2 className="text-md font-normal">
              <h1 className="text-4xl tracking-wider uppercase text-black font-bold z-50">
                {blog.title}
              </h1>
              <div className="flex flex-row gap-4">
                <h5>{blog.createdby} // posted on -{" "}
                {new Date(blog.posted).toLocaleDateString()}</h5>
              </div>
            </h2>
          </div>
        )}

        {blog.excerpts && (
          <div
            className="mt-10 mb-4 text-left"
            dangerouslySetInnerHTML={{ __html: blog.excerpts }}
          />
        )}

        {/* Top image */}
        {blog.image && (
          <img
            src={`/assets/upload/${blog.image}`} // Ensure the logo path is correct
            className="mx-auto h-[500px] w-full mb-8"
            alt={`${blog.title} Logo`} // Ensure the alt attribute is correct
          />
        )}
        {/* Descreption image */}
        {blog.description && (
          <div
            className="mb-10 text-left"
            dangerouslySetInnerHTML={{ __html: blog.description }}
          />
        )}
      </div>
    </div>
  );
};

export default SingleBlog;
